import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import LegalPublicLayout from "./LegalPublicLayout";
import { LegalSectionBody } from "./LegalSectionBody";
import type { LegalSectionBlock } from "./legalSectionTypes";

const sections: LegalSectionBlock[] = [
  {
    title: "1. Tipul serviciilor",
    content:
      "AIFoiParcurs oferă servicii digitale, software, accesibile online pe bază de abonament sau plată unică.",
  },
  {
    title: "2. Perioada de testare",
    content:
      "Aplicația oferă posibilitatea unei perioade de testare gratuită, prin care utilizatorii pot evalua funcționalitățile înainte de efectuarea unei plăți.",
    footer:
      "Se recomandă utilizarea acestei perioade pentru a verifica dacă serviciul corespunde nevoilor utilizatorului.",
  },
  {
    title: "3. Abonamente și reînnoire automată",
    content: "Serviciile pot fi achiziționate sub formă de:",
    bullets: [
      "abonament lunar;",
      "abonament trimestrial;",
      "abonament anual;",
      "plată unică.",
    ],
    footer:
      "Abonamentele se reînnoiesc automat la expirarea perioadei achitate. Utilizatorul va fi taxat automat la începutul noii perioade de facturare, cu excepția cazului în care abonamentul este anulat înainte de reînnoire.",
  },
  {
    title: "4. Anularea abonamentului",
    content: "Utilizatorul poate anula abonamentul în orice moment direct din contul său.",
    bullets: ["anularea oprește reînnoirea automată;", "anularea nu afectează perioada deja achitată."],
    footer: "Accesul la servicii rămâne activ până la finalul perioadei plătite.",
  },
  {
    title: "5. Politica de rambursare",
    content: "Având în vedere natura digitală a serviciilor oferite:",
    bullets: [
      "serviciile sunt furnizate imediat după efectuarea plății;",
      "utilizatorul își exprimă acordul pentru începerea executării serviciului.",
    ],
    footer:
      "Prin efectuarea plății, utilizatorul confirmă că înțelege și acceptă că nu beneficiază de dreptul de retragere, conform legislației aplicabile contractelor la distanță. În mod general, sumele achitate nu sunt rambursabile.",
  },
  {
    title: "6. Excepții",
    content: "Rambursarea poate fi acordată, la cerere, în următoarele situații:",
    bullets: [
      "aplicația nu poate fi utilizată din cauza unor erori tehnice majore imputabile platformei;",
      "tranzacția a fost efectuată din eroare, de exemplu plată dublă;",
      "alte situații justificate, analizate individual.",
    ],
    footer:
      "Nu se acordă rambursări pentru neutilizarea serviciului, nemulțumiri subiective sau neînțelegerea funcționalităților, în condițiile existenței perioadei de testare.",
  },
  {
    title: "7. Facturare",
    content:
      "Emiterea facturii fiscale confirmă finalizarea tranzacției. În mod obișnuit, nu se acordă rambursări după emiterea facturii, cu excepția cazurilor prevăzute la secțiunea „Excepții”.",
  },
];

export default function PoliticaRambursarePage() {
  return (
    <LegalPublicLayout>
      <Seo {...seoFromPublicPage("/politica-de-rambursare")} />
      <main className="legal-doc">
        <div className="legal-doc__inner">
          <Link to="/" className="legal-doc__back">
            Înapoi la pagina principală
          </Link>

          <div className="legal-doc__panel">
            <p className="legal-doc__eyebrow">Politica de anulare și rambursare</p>
            <h1 className="legal-doc__title">Politica de anulare și rambursare</h1>

            <div className="legal-doc__sections">
              {sections.map((section) => (
                <LegalSectionBody key={section.title} section={section} />
              ))}
            </div>
          </div>
        </div>
      </main>
    </LegalPublicLayout>
  );
}
